import { HelpModal } from '@components'

import { Color, Flex, Link, SectionMessage, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenHelpCenter } from '../../../../hooks/useOpenHelpCenter'
import { useVatDeclaration } from '../../context/vatDeclarationContext'

export const VatDeclarationsSubmissionFailedBanner = () => {
  const { t } = useTranslation()
  const { closeSubmissionFailedBanner } = useVatDeclaration()
  const { isHelpCenterEnabled, openHelp } = useOpenHelpCenter()

  const handleSupportClick = useCallback(() => {
    openHelp()
  }, [openHelp])

  const message = (
    <Flex flexDirection="column" width="100%">
      <Text color={Color.Grey950}>{t('vat_declarations.submission_failed_banner.message')}</Text>
      <Link onClick={handleSupportClick}>
        <Text color={Color.Grey950} weight="bold">
          {t('contact.support')}
        </Text>
      </Link>
    </Flex>
  )

  return (
    <>
      <SectionMessage
        onClose={closeSubmissionFailedBanner}
        title={t('vat_declarations.submission_failed_banner.header')}
        variant="error"
        closable
      >
        {message}
      </SectionMessage>
      {!isHelpCenterEnabled && <HelpModal />}
    </>
  )
}
